/* ============================================================
   CHILI DEALS — light/dark theme toggle
   Any element with .theme-toggle flips <html data-theme> and
   persists to localStorage('chili-theme'). Delegated so it also
   works for toggles injected by the theme editor.
   ============================================================ */
(function () {
  function setTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem('chili-theme', t); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.theme-toggle');
    if (!btn) return;
    e.preventDefault();
    var cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    setTheme(cur === 'dark' ? 'light' : 'dark');
  });
})();

/* ============================================================
   CHILI DEALS — /cart redirect handler
   templates/cart.liquid sends /cart to "/?cart=true". Nothing was reading
   that param, so the redirect silently dumped visitors on the homepage.
   Open the cart drawer instead, then clean the URL.
   ============================================================ */
(function () {
  function openCartFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('cart') !== 'true') return;

    params.delete('cart');
    var qs = params.toString();
    history.replaceState(
      null,
      '',
      window.location.pathname + (qs ? '?' + qs : '') + window.location.hash
    );

    var drawer = document.getElementById('offcanvas-cart');
    if (drawer && window.bootstrap) {
      window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartFromUrl);
  } else {
    openCartFromUrl();
  }
})();

/* ============================================================
   CHILI DEALS — live countdown
   Any element with [data-chili-countdown] whose text is "HH:MM:SS"
   (or with [data-duration] seconds) ticks down once per second.
   Evergreen: the end time persists per visitor in localStorage and
   loops back to the start when it expires, so it never sticks at 0.
   ============================================================ */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(s) { return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60); }
  function parse(t) {
    var p = (t || '').trim().split(':').map(function (x) { return parseInt(x, 10); });
    if (p.length === 3 && p.every(function (n) { return !isNaN(n); })) return p[0] * 3600 + p[1] * 60 + p[2];
    return 0;
  }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-chili-countdown]').forEach(function (el) {
      if (el._chiliCd) return;
      el._chiliCd = true;
      var dur = parseInt(el.getAttribute('data-duration'), 10) || parse(el.textContent) || (3 * 3600);
      var key = 'chili-cd-' + (el.getAttribute('data-cd-key') || 'default');
      var now = Date.now(), stored = 0;
      try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (_) {}
      var end = (stored && stored > now) ? stored : now + dur * 1000;
      try { localStorage.setItem(key, String(end)); } catch (_) {}
      function tick() {
        var rem = Math.round((end - Date.now()) / 1000);
        if (rem <= 0) { end = Date.now() + dur * 1000; try { localStorage.setItem(key, String(end)); } catch (_) {} rem = dur; }
        el.textContent = fmt(rem);
      }
      tick();
      el._chiliInt = setInterval(tick, 1000);
    });
  }
  if (document.readyState !== 'loading') initCountdowns();
  document.addEventListener('DOMContentLoaded', function () { initCountdowns(); });
  document.addEventListener('shopify:section:load', function (e) { initCountdowns(e.target); });
})();

/* ============================================================
   CHILI DEALS — product gallery thumbnail switcher
   A gallery root [data-chili-gallery] with a main <img data-chili-main>
   and thumbnail buttons [data-chili-thumb][data-full="<url>"]. Clicking a
   thumb swaps the main image and marks the active thumb. Delegated, so it
   works for theme-editor-injected sections too.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('[data-chili-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-chili-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-chili-main]');
    var full = thumb.getAttribute('data-full');
    if (main && full) {
      main.src = full;
      var srcset = thumb.getAttribute('data-srcset');
      if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
      var alt = thumb.getAttribute('data-alt'); if (alt) main.alt = alt;
    }
    gallery.querySelectorAll('[data-chili-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });
})();

/* ============================================================
   CHILI DEALS — copy coupon code
   Any [data-chili-copy][data-code] copies the code to the clipboard and
   briefly shows a "Copied!" state (swaps the text of its .cpn-do child).
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-chili-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-code') || '';
    var label = btn.querySelector('.cpn-do');
    var done = function () {
      btn.classList.add('copied');
      if (label) label.textContent = btn.getAttribute('data-copied') || 'Copied!';
      setTimeout(function () {
        btn.classList.remove('copied');
        if (label) label.textContent = btn.getAttribute('data-copy-label') || 'Tap to copy';
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else { done(); }
  });
})();